var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeppelinVidaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.297,4.816v6.855c0,0.141-0.059,0.246-0.176,0.316L9.246,16.77c-0.047,0.047-0.117,0.07-0.211,0.07 c-0.07,0-0.129-0.023-0.176-0.07l-7.875-4.781c-0.117-0.07-0.176-0.176-0.176-0.316V4.746V4.641 c0.07-0.422,0.281-0.738,0.633-0.949c0-0.023,0.012-0.035,0.035-0.035l2.777-1.828C4.699,1.594,5.145,1.582,5.59,1.793l3.48,2.039 l3.445-2.004c0.445-0.234,0.879-0.246,1.301-0.035l2.812,1.828C17.074,3.902,17.297,4.301,17.297,4.816z M1.547,11.461l7.137,4.324 v-2.074l-4.711-3.094c-0.117-0.07-0.176-0.176-0.176-0.316V6.574c0-0.047,0.012-0.082,0.035-0.105 C3.879,6.141,4.02,5.906,4.254,5.766L4.289,5.73l1.16-0.703C5.754,4.84,6.082,4.829,6.434,4.992l2.25,1.371V4.5l-3.48-2.039 c-0.234-0.093-0.422-0.093-0.562,0L1.898,4.254L1.863,4.289C1.676,4.407,1.582,4.57,1.582,4.781L1.547,4.816V11.461z M13.57,9.914 v-3.34c0-0.117-0.059-0.199-0.176-0.246L12.27,5.66c-0.07-0.023-0.152-0.023-0.246,0L9.246,7.348c-0.117,0.07-0.246,0.07-0.387,0 L6.082,5.66c-0.07-0.023-0.152-0.023-0.246,0l-1.09,0.668c-0.023,0.023-0.047,0.035-0.07,0.035C4.605,6.434,4.57,6.516,4.57,6.609 v3.48l4.465,2.953L13.57,9.914z M16.559,4.816c0-0.258-0.105-0.434-0.316-0.527l-2.777-1.828c-0.211-0.093-0.398-0.093-0.562,0 L9.422,4.5v1.863l2.25-1.336C12,4.816,12.316,4.805,12.621,4.992l1.16,0.668c0.352,0.188,0.527,0.492,0.527,0.914v3.551 c0,0.141-0.059,0.246-0.176,0.316l-4.711,3.234v2.109l7.137-4.324V4.816z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeppelinVidaIcon);
export default __webpack_public_path__ + "static/media/zeppelin-vida-icon.c2ce7536.svg";
export { ForwardRef as ReactComponent };